import { useEffect, useState } from "react";

import {  Link, useLocation, useNavigate } from "react-router-dom";

import Topbar from "../Layouts/Topbar";
import Header from "../Layouts/Header";
import Footer from "../Layouts/Footer";

import MovieShowCalendar from "./MovieShowCalendar";

import { numberFormatter } from "../lib/utils";

import { API } from "../constants";

import useCompanyStore from "../hooks/useCompanyStore";
import useAuthStore from "../hooks/useAuthStore";
import useCartStore from "../hooks/useCartStore";

const MovieScreenDetails = () => {


  const location = useLocation();

  const navigate = useNavigate();

  const { companyId } = useCompanyStore();

  const { user } = useAuthStore();

  const { setCartItemCount } = useCartStore();

  const loggedInUser = user?.user || user || null;

  const customerId = loggedInUser?._id || loggedInUser?.id || null;

  const customerName = [loggedInUser?.firstName, loggedInUser?.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();

  const customerPhone = loggedInUser?.phoneNumber || "";

  const customerEmail = loggedInUser?.email || "";

  const [cartLoading, setCartLoading] = useState(false);

  const [addingFoodId, setAddingFoodId] = useState("");

  const extractCart = (result) => {
    return result?.data?.cart || result?.cart || result?.data || null;
  };

  const updateLocalCart = (result) => {
    const cart = extractCart(result);

    if (cart && cart._id) {
      const items = Array.isArray(cart.items) ? cart.items : [];

      setCartItemCount(items.length);

      return cart;
    }

    return null;
  };

  const passedMovie = location.state?.movie;

  const passedScreen = location.state?.screen;

  const passedSelectedTime = location.state?.selectedTime;

  const passedSelectedDate = location.state?.selectedDate;



  const screen = passedScreen
    ? {
        id: passedMovie.id,

        title: passedScreen.screenName || passedMovie?.screen || "Screen",

        description:
          passedMovie?.description ||
          passedScreen.description ||
          "Enjoy a premium drive-in movie experience with comfortable parking space, clear sound, and a beautiful big screen atmosphere.",

        theater: passedScreen.theater || passedScreen.theaterName || "",

        adultPrice:
          Number(passedMovie?.adult_ticket_price) ||
          Number(passedMovie?.rawMovie?.adult_ticket_price) ||
          Number(passedScreen.adultPrice) ||
          0,

        childPrice:
          Number(passedMovie?.child_ticket_price) ||
          Number(passedMovie?.rawMovie?.child_ticket_price) ||
          Number(passedScreen.childPrice) ||
          0,

        showDates:
          passedMovie?.showDates ||
          passedMovie?.show_dates ||
          passedMovie?.rawMovie?.showDates ||
          passedMovie?.rawMovie?.show_dates ||
          passedScreen.showDates ||
          passedScreen.show_dates ||
          [],

        shows:
          passedMovie?.showtimes?.length > 0
            ? passedMovie.showtimes.map((item, index) => ({
                id: item._id || item.id || index + 1,

                time: item.start_time || item.time || "",

                movieName:
                  item.movie_title ||
                  item.nowShowing ||
                  passedMovie?.title ||
                  "Untitled Movie",

                movieImage:
                  item.poster_image ||
                  item.image ||
                  passedMovie?.image ||
                  "../assets/images/no-image.jpg",

                genre: item.genre || passedMovie?.genre || "",

                suitability_label:
                  item.suitability_label ||
                  passedMovie?.suitability_label ||
                  "",

                description:
                  item.description ||
                  passedMovie?.description ||
                  passedScreen.description ||
                  "",

                duration: item.duration || passedMovie?.duration || "",

                language: item.language || passedMovie?.language || "",

                rating: item.rating || passedMovie?.rating || "",

                adultPrice:
                  Number(item.adult_ticket_price) ||
                  Number(passedMovie?.adult_ticket_price) ||
                  Number(passedMovie?.rawMovie?.adult_ticket_price) ||
                  0,

                childPrice:
                  Number(item.child_ticket_price) ||
                  Number(passedMovie?.child_ticket_price) ||
                  Number(passedMovie?.rawMovie?.child_ticket_price) ||
                  0
              }))
            : [
                {
                  id: passedMovie?._id || passedMovie?.id,

                  time: passedMovie?.time || "",

                  movieName: passedMovie?.title || "Untitled Movie",

                  movieImage:
                    passedMovie?.image || "../assets/images/no-image.jpg",

                  genre: passedMovie?.genre || "",

                  suitability_label: passedMovie?.suitability_label || "",

                  description: passedMovie?.description || "",

                  duration: passedMovie?.duration || "",

                  language: passedMovie?.language || "",

                  rating: passedMovie?.rating || "",

                  adultPrice:
                    Number(passedMovie?.adult_ticket_price) ||
                    Number(passedMovie?.rawMovie?.adult_ticket_price) ||
                    0,

                  childPrice:
                    Number(passedMovie?.child_ticket_price) ||
                    Number(passedMovie?.rawMovie?.child_ticket_price) ||
                    0,
                },
              ],
      }
    : null;

      

  const defaultSelectedShowId =
    screen?.shows?.find((show) => show.time === passedSelectedTime)?.id ||
    screen?.shows?.[0]?.id ||
    1;

  const [selectedShowId, setSelectedShowId] = useState(defaultSelectedShowId);

  const [showBooking, setShowBooking] = useState(false);

  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [showFoodBooking, setShowFoodBooking] = useState(false);

  const todayDate = new Date().toISOString().slice(0, 10);

  const [selectedBookingDate, setSelectedBookingDate] = useState(
    passedSelectedDate || todayDate,
  );

  const [showDateCalendar, setShowDateCalendar] = useState(false);

  const [adults, setAdults] = useState(1);

  const [children, setChildren] = useState(0);

  const [activeFoodCategory, setActiveFoodCategory] = useState("");

  const [foodCategories, setFoodCategories] = useState([]);

  const [foodItems, setFoodItems] = useState([]);

  const [loadingFoodItems, setLoadingFoodItems] = useState(false);

  const [modifierModalProduct, setModifierModalProduct] = useState(null);

  const [selectedModifierId, setSelectedModifierId] = useState("");

  const generateProductArray = (products = []) => {
    return products.map((item) => ({
      id: item._id,

      categoryId: item.categoryId,

      subCategoryId: item.subCategoryId,

      name: item.productName || "",

      description: item.productDescription || "",

      price: Number(item.salePriceExcludingTax || 0),

      productTax: Number(item.taxRate || 0),

      image: item.productImage,

      allergens: item.allergens || "",

      calories: item.calories || "",

      weight: item.weight || "",

      modifiers: Array.isArray(item.modifiers) ? item.modifiers : [],

      rawProduct: item,
    }));
  };

  const fetchFoodCategories = async () => {
    if (!companyId) {
      return;
    }

    try {
      const response = await fetch(`${API.LIST_FOOD_CATEGORIES}/${companyId}`);

      const result = await response.json();

      if (!response.ok || result.status === false) {
        setFoodCategories([]);

        setActiveFoodCategory("");

        return;
      }

      const categories = Array.isArray(result.data) ? result.data : [];

      setFoodCategories(categories);

      if (categories.length > 0) {
        setActiveFoodCategory(categories[0]._id);
      }
    } catch (error) {
      console.error("Food category error:", error);

      setFoodCategories([]);
    }
  };

  const fetchProductByCategoryId = async (categoryId) => {
    if (!categoryId || !companyId) {
      setFoodItems([]);

      return;
    }

    try {
      setLoadingFoodItems(true);

      const response = await fetch(
        `${API.LIST_PRODUCTBY_CATEGORYID}/${categoryId}/${companyId}`,
      );

      const result = await response.json();

      if (!response.ok || result.status === false) {
        setFoodItems([]);

        return;
      }

      setFoodItems(generateProductArray(result.data || []));
    } catch (error) {
      console.error("Food product error:", error);

      setFoodItems([]);
    } finally {
      setLoadingFoodItems(false);
    }
  };

  useEffect(() => {
    fetchFoodCategories();
  }, [companyId]);

  useEffect(() => {
    fetchProductByCategoryId(activeFoodCategory);
  }, [activeFoodCategory, companyId]);

  if (!screen) {
    return (
      <div>
        <Topbar />

        <Header />

        <section className="screen-details-section">
          <div className="container">
            <h2>Screen details not found</h2>

            <p>Please go back and select a movie again.</p>

            <Link to="/">Back to Home</Link>
          </div>
        </section>

        <Footer />
      </div>
    );
  }

  const selectedShow =
    screen.shows.find((show) => show.id === selectedShowId) || screen.shows[0];


  const formattedBookingDate = new Date(
    `${selectedBookingDate}T00:00:00`,
  ).toLocaleDateString("en-US", {
    weekday: "short",

    month: "short",

    day: "numeric",

    year: "numeric",
  });

  const adultPrice = Number(selectedShow.adultPrice || screen.adultPrice || 0);

  const childPrice = Number(selectedShow.childPrice || screen.childPrice || 0);

  const ticketTotal = adults * adultPrice + children * childPrice;






  const getTicketId = (ticket, fallback = null) => {
    return (
      ticket?._id
    );
  };

  const getTicketName = (ticket, fallback) => {
    return (
      ticket?.ticketType ||
      ticket?.ticket_type ||
      ticket?.ticketTypeName ||
      ticket?.ticket_type_name ||
      ticket?.name ||
      fallback
    );
  };

  const addToCartApi = async (items) => {
    if (!customerId) {
      navigate("/login");

      return null;
    }

    if (!companyId) {
      console.error("Company ID missing");

      return null;
    }

    if (!Array.isArray(items) || items.length === 0) {
      return null;
    }

    try {
      setCartLoading(true);

      const payload = {
        companyId: String(companyId),

        customerId: String(customerId),

        customerName,

        customerPhone,

        customerEmail,

        items,
      };
      payload.bookingDate = selectedBookingDate;
      payload.bookingTime = selectedShow.time;

      const response = await fetch(API.ADD_TO_CART, {
        method: "POST",

        credentials: "include",

        headers: {
          Accept: "application/json",

          "Content-Type": "application/json",
        },

        body: JSON.stringify(payload),
      });

      const result = await response.json().catch(() => null);

      if (!response.ok || result?.status === false || result?.status === 0) {
        console.error("Add to cart failed:", result);

        window.alert(result?.message || "Unable to add item to cart.");

        return null;
      }

      return updateLocalCart(result);
    } catch (error) {
      console.error("Add to cart error:", error);

      window.alert("Something went wrong while adding item to cart.");

      return null;
    } finally {
      setCartLoading(false);
    }
  };

  const handleShowChange = (showId) => {
    setSelectedShowId(showId);

    setShowBooking(false);

    setShowConfirmModal(false);

    setShowFoodBooking(false);

    setAdults(1);

    setChildren(0);

    setModifierModalProduct(null);

    setSelectedModifierId("");
  };



  const handleBookNow = async () => {
    if (!customerId) {
      navigate("/login");

      return;
    }

    const newTicketItems = [];

    if (adults > 0) {
      const ticketName = "Adult";

      const quantity = Number(adults);

      const unitPrice = Number(adultPrice);

      const subtotal = Number((quantity * unitPrice).toFixed(2));

      newTicketItems.push({
        itemId: screen.id,

        itemType: "ticket",

        categoryId: null,

        itemName: `${ticketName} - ${selectedShow.movieName}`,


        quantity,

        unitPrice,

        subtotal,

        taxRate: 0,

        taxAmount: 0,

        discountAmount: 0,

        discountReasonId: null,

        discountReason: null,

        discountMethod: null,

        discountValue: 0,

        discountPercentage: 0,

        options: [],

        totalAmount: subtotal,

        notes: "",
      });
    }

    if (children > 0) {
      const ticketName = "Child";

      const quantity = Number(children);

      const unitPrice = Number(childPrice);

      const subtotal = Number((quantity * unitPrice).toFixed(2));

      newTicketItems.push({
        itemId: screen.id,

        itemType: "ticket",

        categoryId: null,

        itemName: `${ticketName} - ${selectedShow.movieName}`,

        quantity,

        unitPrice,

        subtotal,

        taxRate: 0,

        taxAmount: 0,

        discountAmount: 0,

        discountReasonId: null,

        discountReason: null,

        discountMethod: null,

        discountValue: 0,

        discountPercentage: 0,

        options: [],

        totalAmount: subtotal,

        notes: "",
      });
    }

    const cart = await addToCartApi(newTicketItems);

    if (cart) {
      setShowConfirmModal(false);

      setShowFoodBooking(true);
    }
  };

  const addFoodItem = async (item) => {
    if (!customerId) {
      navigate("/login");

      return;
    }

    if (!item) {
      return;
    }

    const hasModifiers =
      Array.isArray(item.modifiers) && item.modifiers.length > 0;

    if (hasModifiers) {
      setModifierModalProduct(item);

      setSelectedModifierId(
        item.modifiers[0]?._id || item.modifiers[0]?.id || "",
      );

      return;
    }

    try {
      setAddingFoodId(item.id);

      const quantity = 1;

      const unitPrice = Number(item.price || 0);

      const subtotal = Number((unitPrice * quantity).toFixed(2));

      const taxRate = Number(item.productTax || 0);

      const taxAmount = Number((subtotal * (taxRate / 100)).toFixed(2));

      const totalAmount = Number((subtotal + taxAmount).toFixed(2));

      await addToCartApi([
        {
          itemId: item.id,

          itemType: "food",

          categoryId: item.categoryId || null,

          itemName: item.name || "Product",

          image: item.image,

          quantity: 1,

          unitPrice,

          subtotal,

          taxRate,

          taxAmount,

          discountAmount: 0,

          discountReasonId: null,

          discountReason: null,

          discountMethod: null,

          discountValue: 0,

          discountPercentage: 0,

          options: [],

          totalAmount,

          notes: "",
        },
      ]);
    } finally {
      setAddingFoodId("");
    }
  };

  const closeModifierModal = () => {
    setModifierModalProduct(null);

    setSelectedModifierId("");
  };

  const handleConfirmModifier = async () => {
    if (!modifierModalProduct) {
      return;
    }

    if (!customerId) {
      navigate("/login");

      return;
    }

    const selectedModifier = modifierModalProduct.modifiers.find(
      (modifier) =>
        String(modifier._id || modifier.id) === String(selectedModifierId),
    );

    if (!selectedModifier) {
      return;
    }

    const modifierId = selectedModifier._id || selectedModifier.id;

    const modifierPrice = Number(
      selectedModifier.price || selectedModifier.modifierPrice || 0,
    );

    const basePrice = Number(modifierModalProduct.price || 0);

    const unitPrice = Number((basePrice + modifierPrice).toFixed(2));

    const quantity = 1;

    const subtotal = Number((unitPrice * quantity).toFixed(2));

    const taxRate = Number(modifierModalProduct.productTax || 0);

    const taxAmount = Number((subtotal * (taxRate / 100)).toFixed(2));

    const totalAmount = Number((subtotal + taxAmount).toFixed(2));

    const cart = await addToCartApi([
      {
        itemId: modifierModalProduct.id,

        itemType: "food",

        categoryId: modifierModalProduct.categoryId || null,

        itemName: modifierModalProduct.name || "Product",

        image: modifierModalProduct.image,

        quantity: 1,

        unitPrice,

        subtotal,

        taxRate,

        taxAmount,

        discountAmount: 0,

        discountReasonId: null,

        discountReason: null,

        discountMethod: null,

        discountValue: 0,

        discountPercentage: 0,

        options: [
          {
            id: String(modifierId),

            modifierId: String(modifierId),

            name:
              selectedModifier.modifierName ||
              selectedModifier.name ||
              "Modifier",

            modifierName:
              selectedModifier.modifierName ||
              selectedModifier.name ||
              "Modifier",

            price: modifierPrice,

            qty: 1,
          },
        ],

        totalAmount,

        notes: "",
      },
    ]);

    if (cart) {
      closeModifierModal();
    }
  };

  const handleConfirmFoodOrder = () => {
    if (!customerId) {
      navigate("/login");

      return;
    }

    navigate("/cart");
  };

  return (
    <div>
      <Topbar />

      <Header />

      {!showFoodBooking ? (
        <>
          <section className="screen-details-section">
            <div className="container">
              <div className="screen-details-unique">
                <div className="screen-hero-card">
                  <img
                    key={selectedShow.movieImage}
                    src={
                      selectedShow.movieImage || "../assets/images/no-image.jpg"
                    }
                    alt={selectedShow.movieName}
                    onError={(event) => {
                      event.currentTarget.src = "../assets/images/no-image.jpg";
                    }}
                  />

                  <div className="screen-hero-overlay">
                    <span className="screen-label">{screen.title}</span>

                    <h2>{selectedShow.movieName}</h2>

                    {selectedShow.suitability_label && (
                      <p>
                        <i className="fa-solid fa-circle-info" />

                        {selectedShow.suitability_label}
                      </p>
                    )}

                    {selectedShow.genre && (
                      <p>
                        <i className="fa-solid fa-film" />

                        {selectedShow.genre}
                      </p>
                    )}

                    {selectedShow.rating && (
                      <p>
                        <i className="fa-solid fa-star" />

                        {selectedShow.rating}
                      </p>
                    )}
                  </div>
                </div>

                <div className="screen-info-panel">
                  <div className="screen-about-box">
                    <p>{selectedShow.description || screen.description}</p>
                  </div>

                  <div className="details-middle-grid">
                    <div className="screen-stats">
                      <div>
                        <i className="fa-solid fa-clock" />

                        <span>Selected Time</span>

                        <strong>{selectedShow.time}</strong>
                      </div>

                      <div>
                        <i className="fa-solid fa-user" />

                        <span>Adult Ticket</span>

                        <strong>{numberFormatter.format(adultPrice)}</strong>
                      </div>

                      <div>
                        <i className="fa-solid fa-child" />

                        <span>Child Ticket</span>

                        <strong>{numberFormatter.format(childPrice)}</strong>
                      </div>
                    </div>

                    <div className="show-timing-box details-timing-box">
                      <h3>Select Show Timing</h3>

                      <div className="details-timing-list">
                        {screen.shows.map((show) => (
                          <button
                            type="button"
                            key={show.id}
                            className={
                              selectedShowId === show.id ? "active" : ""
                            }
                            onClick={() => handleShowChange(show.id)}
                          >
                            <span>{show.time}</span>

                            <small>{show.movieName}</small>
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>

                  {!showBooking ? (
                    <button
                      type="button"
                      className="booking-btn details-booking-btn"
                      onClick={() => setShowBooking(true)}
                    >
                      Ticket Booking
                    </button>
                  ) : (
                    <div className="ticket-booking-box unique-booking-box">
                      <h3>Book Your Tickets</h3>

                      <div className="selected-booking-movie">
                        <i className="fa-solid fa-ticket" />

                        <div>
                          <span>{selectedShow.time}</span>

                          <strong>{selectedShow.movieName}</strong>
                        </div>
                      </div>

                      <div className="booking-date-row">
                        <div>
                          <span>Selected Date</span>

                          <strong>{formattedBookingDate}</strong>
                        </div>

                        <button
                          type="button"
                          className="other-dates-btn"
                          onClick={() => setShowDateCalendar(true)}
                        >
                          Other Dates
                        </button>
                      </div>

                      <div className="ticket-input-row">
                        <label htmlFor="adult-ticket-count">
                          No. of Adults
                        </label>

                        <input
                          id="adult-ticket-count"
                          type="number"
                          min="1"
                          value={adults}
                          onChange={(event) =>
                            setAdults(
                              Math.max(1, Number(event.target.value) || 1),
                            )
                          }
                        />
                      </div>

                      <div className="ticket-input-row">
                        <label htmlFor="child-ticket-count">
                          No. of Children
                        </label>

                        <input
                          id="child-ticket-count"
                          type="number"
                          min="0"
                          value={children}
                          onChange={(event) =>
                            setChildren(
                              Math.max(0, Number(event.target.value) || 0),
                            )
                          }
                        />
                      </div>

                      <div className="booking-total">
                        Total:{" "}
                        <strong>{numberFormatter.format(ticketTotal)}</strong>
                      </div>

                      <button
                        type="button"
                        className="booking-btn"
                        onClick={() => setShowConfirmModal(true)}
                      >
                        Book Now
                      </button>
                    </div>
                  )}

                  <Link to="/" className="back-home-link">
                    <i className="fa-solid fa-arrow-left" /> Back to Home
                  </Link>
                </div>
              </div>
            </div>
          </section>

          {showConfirmModal && (
            <div className="booking-modal-overlay">
              <div className="booking-success-modal">
                <button
                  type="button"
                  className="booking-modal-close"
                  onClick={() => setShowConfirmModal(false)}
                >
                  ×
                </button>

                <div className="booking-success-icon">
                  <i className="fa-solid fa-check" />
                </div>

                <span className="booking-success-label">Booking Overview</span>

                <h2>{selectedShow.movieName}</h2>

                <div className="booking-summary-card">
                  <div>
                    <i className="fa-solid fa-tv" />

                    <span>Screen</span>

                    <strong>{screen.title}</strong>
                  </div>

                  <div>
                    <i className="fa-solid fa-calendar-days" />

                    <span>Date</span>

                    <strong>{formattedBookingDate}</strong>
                  </div>

                  <div>
                    <i className="fa-solid fa-clock" />

                    <span>Time</span>

                    <strong>{selectedShow.time}</strong>
                  </div>

                  <div>
                    <i className="fa-solid fa-users" />

                    <span>Tickets</span>

                    <strong>
                      {adults} Adult
                      {adults !== 1 ? "s" : ""}, {children} Child
                      {children !== 1 ? "ren" : ""}
                    </strong>
                  </div>
                </div>

                <div className="booking-total-modal">
                  <span>Ticket Total</span>

                  <strong>{numberFormatter.format(ticketTotal)}</strong>
                </div>

                <button
                  type="button"
                  className="booking-done-btn"
                  onClick={handleBookNow}
                >
                  Continue
                </button>
              </div>
            </div>
          )}

          {showDateCalendar && (
            <MovieShowCalendar
              shows={screen.shows}
              showDates={screen.showDates}
              selectedDate={selectedBookingDate}
              onDateChange={setSelectedBookingDate}
              onClose={() => setShowDateCalendar(false)}
            />
          )}
        </>
      ) : (
        <section className="food-booking-page">
          <div className="food-booking-top">
            <button
              type="button"
              className="food-back-btn"
              onClick={() => setShowFoodBooking(false)}
            >
              <i className="fa-solid fa-chevron-left" />
            </button>

            <div>
              <h3>{selectedShow.movieName}</h3>

              <p>
                {screen.theater || screen.title} | {formattedBookingDate} |{" "}
                {selectedShow.time}
              </p>
            </div>

            <button
              type="button"
              className="food-skip-btn"
              onClick={handleConfirmFoodOrder}
            >
              Skip
            </button>
          </div>

          <div className="food-booking-wrapper">
            <div className="food-left-area">
              <div className="food-search-card">
                <span>Grab a Bite!</span>

                <div className="food-search-box">
                  <i className="fa-solid fa-search" />

                  <input type="text" placeholder="Search for F&B Items" />
                </div>
              </div>

              <div className="food-category-tabs">
                {foodCategories.map((category) => (
                  <button
                    type="button"
                    key={category._id}
                    className={
                      activeFoodCategory === category._id ? "active" : ""
                    }
                    onClick={() => setActiveFoodCategory(category._id)}
                  >
                    {category.categoryName}
                  </button>
                ))}
              </div>

              <div className="food-items-grid">
                {loadingFoodItems ? (
                  <p className="no-food-text">Loading food items...</p>
                ) : foodItems.length === 0 ? (
                  <p className="no-food-text">
                    No food items found for this category.
                  </p>
                ) : (
                  foodItems.map((item) => {
                    const hasModifiers =
                      Array.isArray(item.modifiers) &&
                      item.modifiers.length > 0;

                    const isAdding = String(addingFoodId) === String(item.id);

                    return (
                      <div className="food-product-card" key={item.id}>
                        <div className="veg-dot" />

                        <img
                          src={`${API.IMAGE_URL}/uploads/product/${item.image}`}
                          alt={item.name}
                          onError={(event) => {
                            event.currentTarget.src =
                              "../assets/images/no-image.jpg";
                          }}
                        />

                        <div className="food-product-info">
                          <h4>{item.name}</h4>

                          <p>
                            {item.allergens
                              ? `Allergens: ${item.allergens}`
                              : ""}

                            {item.weight ? ` ${item.weight}g` : ""}

                            {item.calories ? ` | ${item.calories}kcal` : ""}
                          </p>

                          <strong>{numberFormatter.format(item.price)}</strong>

                          {hasModifiers && (
                            <small className="modifier-available-text">
                              Customization available
                            </small>
                          )}
                        </div>

                        <button
                          type="button"
                          className="food-add-btn"
                          onClick={() => addFoodItem(item)}
                          disabled={isAdding}
                        >
                          {isAdding ? "Adding..." : "Add Item"}
                        </button>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>

          {modifierModalProduct && (
            <div className="booking-modal-overlay">
              <div className="booking-success-modal modifier-select-modal">
                <button
                  type="button"
                  className="booking-modal-close"
                  onClick={closeModifierModal}
                >
                  ×
                </button>

                <span className="booking-success-label">Customize Item</span>

                <h2>{modifierModalProduct.name}</h2>

                <p className="modifier-modal-desc">
                  Select one modifier for this item.
                </p>

                <div className="modifier-option-list">
                  {modifierModalProduct.modifiers.map((modifier) => {
                    const modifierId = modifier._id || modifier.id;

                    const checked =
                      String(selectedModifierId) === String(modifierId);

                    return (
                      <label
                        key={modifierId}
                        className={
                          checked ? "modifier-option active" : "modifier-option"
                        }
                      >
                        <input
                          type="radio"
                          name="foodModifier"
                          value={modifierId}
                          checked={checked}
                          onChange={() => setSelectedModifierId(modifierId)}
                        />

                        <span>
                          {modifier.modifierName || modifier.name || "Modifier"}
                        </span>

                        <strong>
                          +{" "}
                          {numberFormatter.format(
                            Number(
                              modifier.price || modifier.modifierPrice || 0,
                            ),
                          )}
                        </strong>
                      </label>
                    );
                  })}
                </div>

                <div className="booking-total-modal">
                  <span>Item Total</span>

                  <strong>
                    {numberFormatter.format(
                      Number(modifierModalProduct.price || 0) +
                        Number(
                          modifierModalProduct.modifiers.find(
                            (modifier) =>
                              String(modifier._id || modifier.id) ===
                              String(selectedModifierId),
                          )?.price ||
                            modifierModalProduct.modifiers.find(
                              (modifier) =>
                                String(modifier._id || modifier.id) ===
                                String(selectedModifierId),
                            )?.modifierPrice ||
                            0,
                        ),
                    )}
                  </strong>
                </div>

                <button
                  type="button"
                  className="booking-done-btn"
                  onClick={handleConfirmModifier}
                  disabled={!selectedModifierId || cartLoading}
                >
                  {cartLoading ? "Adding..." : "Add Item"}
                </button>
              </div>
            </div>
          )}
        </section>
      )}

      <Footer />
    </div>
  );
};

export default MovieScreenDetails;
